import { ChiefBridge } from "../../libs/chief-bridge";

export interface NativeOutgoingMessage {}

export const bridge = new ChiefBridge<NativeOutgoingMessage>("not-found");
